import React, { Component } from "react";
const loader = require("../../images/loading3.gif");
class Loader extends Component {
  render() {
    return (
      <div id="loader">
        <img src={loader} alt="" />
      </div>
    );
  }
}
export default Loader;
